import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useState } from 'react';
import { Accordion as BSAccordion, Col, Container, Row } from 'react-bootstrap';
import Blockquote from '../../components/Blockquote';
import Button from '../../components/Button';
import NumberInput from '../../components/NumberInput';
import GenericCard from '../../components/GenericCards/GenericCards';
import { OPTIMIZER_SCORE_ROUTE } from '../../routes/types';
import { useNavigate } from 'react-router-dom';

const accordionsData = [
  {
    title: 'Monthly Income and Savings',
    inputFields: [
      {
        label: 'Total Pay',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Net Pay',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Other Income',
        defaultValue: 0,
        value: 0,
      },

      {
        label: '401(k) Contribution',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Health Savings Account Contributions',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Debt Payment',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Ideal Additional Debt Payment',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Other Savings',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Ideal Additional Savings',
        defaultValue: 0,
        value: 0,
      },
    ],
  },

  {
    title: 'Monthly Housing Cost',
    inputFields: [
      {
        label: 'Mortage',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'HOA Fees',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Rent',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Home Insurance',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Repairs/Maintenance',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Water/Gas/Electricity',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Cable/TV/Internet',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Phone/Cell',
        defaultValue: 0,
        value: 0,
      },
    ],
  },

  {
    title: 'Monthly Transportation Costs',
    inputFields: [
      {
        label: 'Car Payment',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Car Insurance',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Gas/Fuel',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Car Repairs',
        defaultValue: 0,
        value: 0,
      },
    ],
  },

  {
    title: 'Monthly Education Costs',
    inputFields: [
      {
        label: 'School Supplies',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Student Loan',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'College Tuition',
        defaultValue: 0,
        value: 0,
      },
    ],
  },

  {
    title: 'Monthly Personal Costs',
    inputFields: [
      {
        label: 'Groceries/Household',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Clothing',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Entertainment',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Medical',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Pet Supplies',
        defaultValue: 0,
        value: 0,
      },

      {
        label: 'Other Expenses',
        defaultValue: 0,
        value: 0,
      },
    ],
  },
];

const netIncomeData = [
  {
    title: 'Monthly Income',
    value: '$4,200',
    incomes: [
      {
        type: 'Monthly Income',
        value: '$4000',
      },

      {
        type: 'Net Monthly Income',
        value: '$200',
      },

      {
        type: '401(k) contributions',
        value: '$0',
      },

      {
        type: 'HSA Contributions',
        value: '$0',
      },

      {
        type: 'Dept Payment',
        value: '$0',
      },

      {
        type: 'Savings Amount',
        value: '$0',
      },
    ],
  },

  {
    title: 'Monthly Expenses',
    value: '-$3,000',
    incomes: [
      {
        type: 'Housing',
        value: '$0',
      },

      {
        type: 'Transportation',
        value: '$0',
      },

      {
        type: 'Education',
        value: '$0',
      },

      {
        type: 'Personal',
        value: '-$3,000',
      },
    ],
  },
];

const incomeAllocationData = [
  {
    title: 'Allocated Monthly Income',
    vlaue: '$200',
    incomes: [
      {
        type: '401(k) contributions',
        value: '$200',
      },

      {
        type: 'HSA Contributions',
        value: '$0',
      },

      {
        type: 'Savings Amount',
        value: '$0',
      },
    ],
  },
];

const Optimizer = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState(accordionsData);

  const handleValueChanges = (
    accordionIndex: number,
    inputIndex: number,
    e: any
  ) => {
    const tempData = [...values];
    tempData[accordionIndex].inputFields[inputIndex].value = e;

    setValues((prev) => (prev = tempData));
  };
  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row>
        <Col className={'col-12 mt-10 mt-lg-13 mb-10 mb-lg-7'}>
          <span className={'text-sm-20-lg-32 fw-normal'}>
            Financial Wellbeing Budget
          </span>
        </Col>

        <Col className={'col-12'}>
          <Blockquote
            children={
              <span className={'text-fs-6 lh-xxs fw-light'}>
                This budgeting tool is meant to calculate an estimate of your
                ‘Available Income’; income that will be allocated to your
                retirement and HSA plans, emergency funds, etc. To properly
                estimate your available income. complete this budgeting tools as
                best as you can. The more complete, the better the Optimizer
                tool will work for you. These amounts should be calculated as a
                monthly amount and can include expenses/income for your entire
                family. Note that retirement savings are included as part of
                your income because the first goal of this tool is to make sure
                you are saving for retirement.
              </span>
            }
          />
        </Col>
      </Row>

      <Row className="d-flex justify-content-between m-0 p-0 mt-12">
        <Col className="m-0 p-0 d-flex flex-column col-12 col-lg-7 pe-lg-4">
          {accordionsData.map((accordion, idx) => (
            <BSAccordion
              className={`${idx !== accordionsData.length - 1 ? 'mb-10' : ''}`}
              key={idx}
              defaultActiveKey="0"
            >
              <BSAccordion.Item eventKey="1" className="white-accordion">
                <BSAccordion.Header>
                  <span className={'m-0 h6 fw-normal'}>{accordion.title}</span>
                </BSAccordion.Header>
                <BSAccordion.Body>
                  <Row>
                    {accordion.inputFields.map((data, i) => (
                      <Col
                        key={i}
                        className={`col-12 col-lg-6 ${
                          idx !== accordion.inputFields.length - 1
                            ? 'mb-10'
                            : ''
                        }`}
                      >
                        <NumberInput
                          minValue={'0'}
                          maxValue={'17'}
                          value={data.value}
                          defaultValue={data.defaultValue}
                          label={data.label}
                          onChange={(e: any) => handleValueChanges(idx, i, e)}
                          icon={light('dollar')}
                        />
                      </Col>
                    ))}
                  </Row>
                </BSAccordion.Body>
              </BSAccordion.Item>
            </BSAccordion>
          ))}
        </Col>

        <Col className="pe-lg-0 col-12 col-lg-5">
          <GenericCard variant={'white'}>
            <Container className={'px-0'}>
              <Row className={'mb-7'}>
                <Col className={'col-12'}>
                  <span className={'h6'}>Net Income</span>
                </Col>
              </Row>

              {netIncomeData.map((data, idx) => (
                <Container key={idx} className={'px-0 mb-10'}>
                  <Row className={'mx-0 border-bottom-light-gray-2px pb-3'}>
                    <Col className={'ps-0 col-6'}>
                      <span className={'lh-xxs text-fs-6 fw-normal'}>
                        {data.title}
                      </span>
                    </Col>
                    <Col className={'pe-0 col-6 text-end'}>
                      <span className={'lh-xxs text-fs-6 fw-normal'}>
                        {data.value}
                      </span>
                    </Col>
                  </Row>

                  {data.incomes.map((income, i) => (
                    <Row
                      key={i}
                      className={`py-3 mx-0 ${
                        i !== data.incomes.length - 1
                          ? 'border-bottom-light-gray-lg'
                          : ''
                      }`}
                    >
                      <Col className={'ps-0 col-6'}>
                        <span className={'lh-xxs text-fs-6 fw-light'}>
                          {income.type}
                        </span>
                      </Col>
                      <Col className={'pe-0 col-6 text-end'}>
                        <span className={'lh-xxs text-fs-6 fw-light'}>
                          {income.value}
                        </span>
                      </Col>
                    </Row>
                  ))}
                </Container>
              ))}

              <Row
                className={
                  'py-3 mx-0 border-bottom-light-gray-2px border-top-light-gray-2px'
                }
              >
                <Col className={'ps-0 col-6'}>
                  <span className={'lh-xxs text-fs-6 fw-normal'}>
                    Available Income
                  </span>
                </Col>

                <Col className={'pe-0 col-6 text-end'}>
                  <span className={'lh-xxs text-fs-6 fw-normal'}>$1,200</span>
                </Col>
              </Row>
            </Container>
          </GenericCard>

          <GenericCard variant={'gray'}>
            <Container className={'px-0'}>
              <Row className={'mb-7'}>
                <Col className={'col-12'}>
                  <span className={'h6'}>Income Allocation</span>
                </Col>
              </Row>

              <>
                {incomeAllocationData.map((data, idx) => (
                  <Container key={idx} className={'px-0 mb-10'}>
                    <Row className={'mx-0 pb-3 border-bottom-light-gray-2px'}>
                      <Col className={'ps-0 col-6'}>
                        <span className={'lh-xxs text-fs-6 fw-normal'}>
                          {data.title}
                        </span>
                      </Col>

                      <Col className={'pe-0 col-6 text-end'}>
                        <span className={'lh-xxs text-fs-6 fw-normal'}>
                          {data.vlaue}
                        </span>
                      </Col>
                    </Row>

                    {data.incomes.map((income, i) => (
                      <Row className={'mx-0 py-3 border-bottom-light-gray-lg'}>
                        <Col className={'ps-0 col-6'}>
                          <span className={'lh-xxs text-fs-6 fw-light'}>
                            {income.type}
                          </span>
                        </Col>

                        <Col className={'pe-0 col-6 text-end'}>
                          <span className={'lh-xxs text-fs-6 fw-light'}>
                            {income.value}
                          </span>
                        </Col>
                      </Row>
                    ))}
                  </Container>
                ))}
              </>

              <Row
                className={
                  'py-3 mx-0 border-bottom-light-gray-2px border-top-light-gray-2px'
                }
              >
                <Col className={'ps-0 col-6'}>
                  <span className={'lh-xxs text-fs-6 fw-normal'}>
                    Unallocated Monthly Income
                  </span>
                </Col>

                <Col className={'pe-0 col-6 text-end'}>
                  <span className={'lh-xxs text-fs-6 fw-normal'}>$1,000</span>
                </Col>
              </Row>
            </Container>
          </GenericCard>
        </Col>
      </Row>

      <Row className={'mt-11'}>
        <Col className={'col-12 text-center'}>
          <Button onClick={() => navigate(OPTIMIZER_SCORE_ROUTE)}>
            Calculate
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Optimizer;
